// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-data-table {
    overflow-x: auto;
    width: 100%;
    text-align: center;
    display: table;
}

tr.game-data-rows {
    font-size: 11pt;
}

.game-data-table-surrounds {
    overflow-x: auto;
}

.form-submit-btn {
    display: block;
    margin: 0;
    padding: 0;
    text-align: center;
    margin-top: 10px;
    width: 80px;

}

.winner {
    font-weight: 600;
}

.nospoilers {
    display: none;
}

.game-data-submit-container {
    margin: 0;
    padding: 0;
    margin-top: 20px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    display: flex;
}

.game-data-submit-container .left {
    width: 40%;
}
.game-data-submit-container .right {
    width: 60%;
}
.game-data-submit-container .left-right {
    width: 100%;
}

form.row {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
}

form.row input {
    margin-top: 8px;
}

form.row .col-sm-6 {
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    color: rgb(82, 93, 104);
}

form.row .or {
    margin-bottom: 20px;
    font-weight: 600;
}

form.row .col-sm-6 input[type="file"] {
    margin-bottom: 16px;
}

.title-small {
    font-weight: 600;
    font-size: 20px;
    color: rgb(87, 107, 131);
    margin-bottom: 8px;
}

.search.game-data {
    margin-bottom: 16px;
    
}

input[type="text"] {
    text-overflow: ellipsis;
    border-radius: 2px;
    border: 1px solid rgb(46, 49, 53);
    font-size: 16px;
    line-height: 20px;
    height: 36px;
    width: 200px;
    box-sizing: border-box;
    padding: 8px;
}

.landing-page-img {
    height: 300px;
    /* width: 180px; */
    display: block;
    margin: auto;
}

.landing-page-title {
    text-decoration: none;
    text-align: center;
    color: black;
}

@media only screen and (max-width: 1000px) { 
    .game-data-submit-container {
        flex-direction: column-reverse;
    }

    .game-data-submit-container .left {
        margin-top: 40px;
        width: 100%;
    }

    .game-data-submit-container .right {
        
        width: 100%;
    }
}

td.roster-imgs img {
    width: 34px;
}

div.spoilerButtonDiv {
    display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/component_css/GameData.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;;AAEf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".game-data-table {\n    overflow-x: auto;\n    width: 100%;\n    text-align: center;\n    display: table;\n}\n\ntr.game-data-rows {\n    font-size: 11pt;\n}\n\n.game-data-table-surrounds {\n    overflow-x: auto;\n}\n\n.form-submit-btn {\n    display: block;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n    margin-top: 10px;\n    width: 80px;\n\n}\n\n.winner {\n    font-weight: 600;\n}\n\n.nospoilers {\n    display: none;\n}\n\n.game-data-submit-container {\n    margin: 0;\n    padding: 0;\n    margin-top: 20px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    display: flex;\n}\n\n.game-data-submit-container .left {\n    width: 40%;\n}\n.game-data-submit-container .right {\n    width: 60%;\n}\n.game-data-submit-container .left-right {\n    width: 100%;\n}\n\nform.row {\n    display: flex;\n    flex-direction: column;\n    margin: 0;\n    padding: 0;\n}\n\nform.row input {\n    margin-top: 8px;\n}\n\nform.row .col-sm-6 {\n    padding: 0;\n    margin: 0;\n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: 700;\n    color: rgb(82, 93, 104);\n}\n\nform.row .or {\n    margin-bottom: 20px;\n    font-weight: 600;\n}\n\nform.row .col-sm-6 input[type=\"file\"] {\n    margin-bottom: 16px;\n}\n\n.title-small {\n    font-weight: 600;\n    font-size: 20px;\n    color: rgb(87, 107, 131);\n    margin-bottom: 8px;\n}\n\n.search.game-data {\n    margin-bottom: 16px;\n    \n}\n\ninput[type=\"text\"] {\n    text-overflow: ellipsis;\n    border-radius: 2px;\n    border: 1px solid rgb(46, 49, 53);\n    font-size: 16px;\n    line-height: 20px;\n    height: 36px;\n    width: 200px;\n    box-sizing: border-box;\n    padding: 8px;\n}\n\n.landing-page-img {\n    height: 300px;\n    /* width: 180px; */\n    display: block;\n    margin: auto;\n}\n\n.landing-page-title {\n    text-decoration: none;\n    text-align: center;\n    color: black;\n}\n\n@media only screen and (max-width: 1000px) { \n    .game-data-submit-container {\n        flex-direction: column-reverse;\n    }\n\n    .game-data-submit-container .left {\n        margin-top: 40px;\n        width: 100%;\n    }\n\n    .game-data-submit-container .right {\n        \n        width: 100%;\n    }\n}\n\ntd.roster-imgs img {\n    width: 34px;\n}\n\ndiv.spoilerButtonDiv {\n    display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
